export default __webpack_public_path__ + "static/preffered-41851ee29dd42fae3565fe2963115f1b.svg";